<template>
  <browse-filter name="Status">
    <browse-filter-radio
      label="All"
      name="status"
      value="all"
      :checked="value === 'all'"
      @click="select"
    />
    <browse-filter-radio
      label="Live deals"
      name="status"
      value="current"
      :checked="value === 'current'"
      @click="select"
    />
    <browse-filter-radio
      label="Ending soon"
      name="status"
      value="ending"
      :checked="value === 'ending'"
      @click="select"
    />
    <browse-filter-radio
      label="Unavailable"
      name="status"
      value="expired"
      :checked="value === 'expired'"
      @click="select"
    />
  </browse-filter>
</template>
<script>
import BrowseFilter from './BrowseFilter.vue';
import BrowseFilterRadio from './BrowseFilterRadio.vue';

export default {
  components: {
    BrowseFilter,
    BrowseFilterRadio,
  },
  props: {
    value: {
      type: String,
      default: 'current',
    },
    statuses: {
      type: Array,
      required: true,
      default: () => ([]),
    },
  },
  methods: {
    select(value) {
      this.$emit('input', value);
    },
  },
};
</script>
